import React, {lazy, Suspense, useEffect} from 'react';
import {ROUTE_PATHS, SEO_TAGS} from "../../../lib/constants";
import {Helmet} from "react-helmet";
const PricingLazyHelper = lazy(() => import('./PricingLazyHelper'));

const PricingPage =()=>  {

    useEffect(() => {
        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>{SEO_TAGS.pricing.title}</title>
                <meta name="description" content={SEO_TAGS.pricing.description}/>
                <link rel="canonical" href={process.env.PUBLIC_URL + '/' + ROUTE_PATHS['pricing']}/>
                <meta property="og:title"  content={SEO_TAGS.pricing.title}/>
                <meta property="og:description" content={SEO_TAGS.pricing.description}/>
                <meta property="og:url" content={process.env.PUBLIC_URL + '/' + ROUTE_PATHS['pricing']}/>
                <meta name="twitter:title" content={SEO_TAGS.pricing.title}/>
                <meta name="twitter:description" content={SEO_TAGS.pricing.description}/>
            </Helmet>
            <Suspense fallback={<div style={{height:"100vh"}}/>}>
                <PricingLazyHelper/>
            </Suspense>
        </React.Fragment>
    );
};

export default PricingPage;
